import { render, staticRenderFns } from "./AIChatting.vue?vue&type=template&id=2bb56591&scoped=true"
import script from "./AIChatting.vue?vue&type=script&lang=js"
export * from "./AIChatting.vue?vue&type=script&lang=js"
import style0 from "./AIChatting.vue?vue&type=style&index=0&id=2bb56591&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb56591",
  null
  
)

export default component.exports